import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["canModifyLinkText", "linkText"];
import I18n from 'I18n';
import { Fieldset } from 'foundations-components/transitional/components/Fieldset';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import PropTypes from 'prop-types';
import { KeyTypes } from '../../constants/popover';
import { omit } from '../../utils/iterables';
//@ts-expect-error untyped module
import LinkFields from './LinkFields';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const renderLinkTextInput = (canModifyLinkText, linkText, onUpdate, handleSubmitOnEnter) => {
  if (!canModifyLinkText) return null;
  const handleInputChange = evt => {
    onUpdate({
      linkText: evt.target.value
    });
  };
  return /*#__PURE__*/_jsx(FormControl, {
    marginBlockEnd: "100",
    label: I18n.text('RichTextLib.links.linkText.label'),
    children: /*#__PURE__*/_jsx(TextInput, {
      "data-test-id": "link-text-input",
      autoFocus: canModifyLinkText,
      autoFocusPreventScroll: true,
      value: linkText,
      onChange: handleInputChange,
      onKeyDown: handleSubmitOnEnter
    })
  });
};
function LinkPopoverControlsV2(props) {
  const {
      canModifyLinkText,
      linkText
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const handleSubmitOnEnter = evt => {
    if (evt.key === KeyTypes.ENTER) {
      props.onSubmit();
      evt.preventDefault();
    }
  };
  return /*#__PURE__*/_jsxs(Fieldset, {
    _size: "small",
    children: [renderLinkTextInput(canModifyLinkText, linkText, props.onUpdate, handleSubmitOnEnter), /*#__PURE__*/_jsx(LinkFields, Object.assign({}, rest, {
      shouldAutoFocus: !canModifyLinkText,
      onUrlKeyDown: handleSubmitOnEnter
    }))]
  });
}
const propTypes = Object.assign({}, omit(['onUrlKeyDown', 'shouldAutoFocus'], LinkFields.propTypes), {
  canModifyLinkText: PropTypes.bool,
  linkText: PropTypes.string
});
LinkPopoverControlsV2.propTypes = propTypes;
LinkPopoverControlsV2.displayName = 'LinkPopoverControlsV2';
export default LinkPopoverControlsV2;